import { memo } from "react";
import { ReactComponent as Meal } from "../../../../../assets/images/meal.svg";
import { ReactComponent as Break } from "../../../../../assets/images/break.svg";
import { ReactComponent as Shabbat } from "../../../../../assets/images/Shabbat.svg";
import { ReactComponent as TripIcon } from "../../../../../assets/images/trip.svg";
import { ReactComponent as PrayIcon } from "../../../../../assets/images/pray.svg";
import styles from "./index.module.scss";

interface SessionTypeIconProps {
    type: string;
}

const SessionTypeIcon = ({ type }: SessionTypeIconProps) => {
    return (
        <div className={styles.icon}>
            {type === "Meal" && <Meal className={styles.svg}  />}
            {type === "Break" && <Break className={styles.svg} />}
            {type === "Shabbat" && <Shabbat className={styles.svg} />}
            {type === "Tiyul" && <TripIcon className={styles.svg} />}
            {type === "Prayer" && <PrayIcon className={styles.svg} />}
        </div>
    )
}

export default memo(SessionTypeIcon);